module.exports = __webpack_public_path__ + "static/fonts/NotoSans-Light.39bc3dc.eot";


//////////////////
// WEBPACK FOOTER
// ./src/views/myprotein-test/assets/fonts/NotoSans-Light.eot?
// module id = 6//o
// module chunks = 0